import Portfolios from "../../components/Portfolios/portfolios"
import "../Portfolio/portfolio.css"

function Portfolio(){
return(
    < Portfolios />
)
}
export default Portfolio